<template>
  <div class="detail">
    <div class="p_title">
      <div class="no">
        <img src="../../assets/60.png" />{{ request.complaintOrder.d365No }}
      </div>
    </div>
    <div class="jd">
      <img src="../../assets/62.png" />{{
      request.complaintOrder.status == 1 ? "已完成" : "待处理"
      }}
    </div>
    <div class="first box">
      <div class="title"><img src="../../assets/63.png" />顾客信息</div>
      <div class="newrow">
        <div class="pr04"><img class="newimg" src="../../assets/73.png" /></div>
        <div>{{ request.complaintOrder.customerCompanyName }}</div>
      </div>
      <div class="newrow">
        <div class="pr04"><img class="newimg" src="../../assets/74.png" /></div>
        <div style="width: 90%">{{ request.complaintOrder.customerAddress }}</div>
      </div>
      <div class="newrow">
        <div class="pr04"><img class="newimg" src="../../assets/75.png" /></div>
        <div>{{ getDateTimeStr(request.complaintOrder.serviceCreateTime) }}</div>
      </div>
      <div class="newrow">
        <div class="pr04"><img class="newimg" src="../../assets/76.png" /></div>
        <div>{{ request.complaintOrder.customerName }}</div>
      </div>
      <div class="newrow">
        <div class="pr04"><img class="newimg" src="../../assets/78.png" /></div>
        <div>{{ request.complaintOrder.customerMobile }}</div>
      </div>
    </div>
    <div class="box">
      <div class="title"><img src="../../assets/63.png" />建议内容</div>
      <div class="newrow">
        <div class="pr04"></div>
        <div style="font-weight: bold; font-size: 1rem">
          {{ request.complaintOrder.categoryName }}
        </div>
      </div>
      <div class="newrow">
        <div class="pr04"></div>
        <div style="width: 90%">{{ request.complaintOrder.customerReason }}</div>
      </div>
    </div>
    <div class="box">
      <div class="title"><img src="../../assets/64.png" />处理进度</div>
     
      
      <div class="second" :class="{ open: isOpen }">
        <div class="operationList" v-for="(item, index) in oparations" :key="index">
          <div class="operationItem">
           
            <img v-if="index == 0" class="img" src="../../assets/66.png" />
            <img v-else-if="index==oparations.length-1" class="img" src="../../assets/68.png" />
            <img class="img" v-else src="../../assets/67.png" />
             <div class="oparationTime">
              {{ getDateTimeStr(item.createDateTime) }}
            </div>
            <div class="oparation" style="width: calc(100% - 12rem)">
              {{ item.action }}
            </div>
            
          </div>
          <div class="operationactions" style="margin-top:0.6rem;" v-if="item.action.indexOf('处理完成') > -1">
              服工{{ item.serviceUserName }}处理完成，{{ item.details }}
          </div>
        </div>

      </div>
      <div class="operationactions" v-if="request.attachmentList != null">
        <attach-upload :canUpload="false" :maxLength="9" v-model="request.attachmentList"></attach-upload>
      </div>
      <div class="btn" :class="{ open: isOpen }" @click="isOpen = !isOpen">
      <img src="../../assets/1.jpg" />
    </div>
    </div>
    

    <mt-popup v-model="popupVisible" class="popup">
      <html style="z-index: 1; width: 100%">
      <div style="padding: 2rem">
        <div class="poopdiv">
          <div style="font-size: 1rem; font-weight: bold; text-align: center">
            处理结果
          </div>
        </div>
        <div style="margin-top: 2rem" class="poopdiv">
          <mt-field placeholder="请输入处理结果" type="textarea" rows="4" v-model="MainRequest.Result"></mt-field>
        </div>
        <div class="poopdiv">
          <div style="font-size: 0.8rem; font-weight: bold">上传处理凭证</div>
          <attach-upload :canUpload="true" :maxLength="9" v-model="MainRequest.attachmentList"></attach-upload>
        </div>
      </div>
      <div class="confirm" style="width: 50%; float: left; background-color: #ff6c70" @click="popupVisible = false">
        取消
      </div>
      <div class="confirm" style="width: 50%; float: left" @click="SetComplateStatus()">
        确认
      </div>

      </html>
    </mt-popup>

    <div v-if="request.complaintOrder.status == 0" class="row_bottom">
      <div class="right" style="background-color: #ff6c70" @click="GoBack">
        返回
      </div>
      <div class="right" @click="popupVisible = !popupVisible">处理</div>
    </div>
    <div v-else class="row_bottom">
      <div class="right" style="width: 100%" @click="GoBack">返回</div>
    </div>
  </div>

</template>
<style scoped>
.popup {
  border-radius: 2rem;
}

.mint-cell {
  display: flex;
}

.newrow {
  display: -webkit-box;
  margin-top: 1rem;
  margin-left: 1rem;
}

.newimg {
  width: 1.2rem;
  padding-right: 1rem;
}

.jdauto {
  line-height: 12px;
  color: #fff;
  padding: 10px 2rem 10px 1rem;
  border-radius: 1rem;
  border-top-right-radius: 0;
  background: -mos-linear-gradient(to right, #f5b80f, #d9a824);
  background: linear-gradient(to right, #f5b80f, #d9a824);

  right: 0;
  z-index: 1;
}

.jdno {
  line-height: 12px;
  color: #fff;
  padding: 10px 2rem 10px 1rem;
  border-radius: 1rem;
  border-top-right-radius: 0;
  background: -mos-linear-gradient(to right, #f50f0f, #f50f0f);
  background: linear-gradient(to right, #f50f0f, #f50f0f);

  right: 0;
  z-index: 1;
}
</style>
<script>
import { Button } from "mint-ui";
import { Indicator } from "mint-ui";
import DataTransfer from "../../common/DataTransfer";
import AttachUpload from "@/components/AttachUpload.vue";
import _ from "lodash";
import { MessageBox, Toast } from "mint-ui";
export default {
  data() {
    return {
      loading: false,
      canLoading: true,
      request: {
        complaintOrder:{},
      },
      isOpen: false,
      serviceid:0,
      popupVisible: false,
      popupVisible1: false,
      popupVisible2: false,
      popupVisible6: false,
      MainRequest: {
        attachmentList: [],
        Result: "",
      },
      currentItem: {},
      oparations: {},
      popupFilterVisible: false,
      slots: [
        {
          values: [
            {
              id: 10,
              name: "顾客经办不在",
            },
            {
              id: 20,
              name: "顾客不需要巡保",
            },
            {
              id: 30,
              name: "无效顾客",
            },
          ],
          defaultIndex: 1,
        },
      ],
    };
  },
  watch: {},
  components: {
    "attach-upload": AttachUpload,
  },
  methods: {
    GoBack() {
      var that = this;
     document.referrer === '' ?
           that.$router.push({
                path: `/`
            }):
            that.$router.go(-1);
    },
    getDateTimeStr(datestr) {
      var date = new Date(datestr);
      var that = this;
      return (
        DataTransfer.dateToString(date) + " " + DataTransfer.dateToTime(date)
      );
    },
    
    SetComplateStatus() {
      var that = this;
      var currentItem = that.request;
      currentItem.Result = that.MainRequest.Result;
      currentItem.attachmentList = that.MainRequest.attachmentList;
      currentItem.id=that.request.id;//这里设置为serviceid
      if (currentItem.Result == undefined || currentItem.Result.length == 0) {
        Toast("请填写原因");
        return false;
      }
     
      Indicator.open();
      that.popupVisible = false;
       debugger;
      that.$axios
        .post("/api/Complaint/SetComplateStatus", currentItem)
        .then((res) => {
          var result = res.data;
          if (result != null && result.isSuccess) {
            that.$router.push({
              path: `/Complaint/list?status=1`,
            });
          } else {
            console.log(result.message);
          }
          Indicator.close();
        })
        .catch((err) => {
          Indicator.close();
          Toast("操作失败，请稍后再试");
          console.log(err);
        });
    },
    GetDetial() {
      var that = this;
      Indicator.open();
      that.$axios
        .get("/api/Complaint/GetMobileDetial?id=" + that.request.id)
        .then((res) => {
          var result = res.data.data;
          that.oparations = result.data.complaintOperationByServiceIdLogs;
          that.request.attachmentList=result.data.attachmentList;
          that.request.complaintOrder=result.data.complaintOrder;
          if (result.data.complaint.length > 0) {
            that.request.customerReason =
              result.data.complaint[0].customerReason;
              that.serviceid= result.data.complaint[result.data.complaint.length-1].id;
              that.request.complaintOrder.customerReason=result.data.complaint[result.data.complaint.length-1].customerReason
          }
          console.log(result);
          Indicator.close();
        })
        .catch((err) => {
          Indicator.close();
          Toast("操作失败，请稍后再试");
          console.log(err);
        });
    },
  },
  mounted() {
    var that = this;
  },
  created() {
    var that = this;
    that.request.id =parseInt(that.$route.query.id);
    
    that.GetDetial();
  },
};
</script>
